export default {
  api:  process.env.REACT_APP_BASE_URL+'/api',
  register: "/register",
  login: "/login",
  forgotPassword: "/forgot-password",
  resetPassword: "/reset-password",
  inspectionType: "/inspection_types",
  companies: "/companies",
  company_type: "/company_type",
  risk_categories: "/risk_categories",
  risk_sub_categories: "/risk_sub_categories",
  risk_sub_categories_type: "/risk_sub_categories_type",
  risk_solutions: "/risk_solutions",
  incident_questions: "/incident_questions",
  priorities: "/incident_priorities",
  assignmentTo: "/assignment_tos",
  generateReport: "/generate_report",
  generateReportTemp: "/generate_report_temp",
  users: "/users",
  plans: "/plans",
  create_subscription: process.env.REACT_APP_BASE_URL+"/api/create_subscription",
  verify_subscription: process.env.REACT_APP_BASE_URL+"/api/verify_subscription",
  get_subscription: "/get_subscription",
  cancel_subscription: "/cancel_subscription",
  assign_subscription: "/assign_subscription",
};
